import { Chart as ChartJS, ChartType, registerables } from "chart.js";
import zoomPlugin from "chartjs-plugin-zoom";
import React, { forwardRef } from "react";
import { Chart } from "react-chartjs-2";
import { CustomChartProps } from "./type";

ChartJS.register(...registerables, zoomPlugin);

const CustomChart = forwardRef(
  <TType extends ChartType>(
    props: CustomChartProps<TType>,
    ref: React.ForwardedRef<ChartJS>,
  ): React.ReactElement => {
    const { type, data, options, plugins, className, id, height, width } =
      props;

    return (
      <Chart
        id={id}
        type={type}
        data={data as never}
        options={options as never}
        plugins={plugins as never}
        className={className}
        height={height}
        width={width}
        // @ts-expect-error - ref type mismatch between ChartJS and react-chartjs-2 internal type
        ref={ref}
      />
    );
  },
);

CustomChart.displayName = "CustomChart";

export default CustomChart;
